import * as React from 'react'
import { Popover } from '@base-ui/react/popover'
import { Toolbar } from '@base-ui/react/toolbar'
import { twMerge } from 'tailwind-merge'
import { ResizableDiv } from '../../resizable-div'
import { ActionPopoverPopup } from './action-popover-popup'

interface ActionPopoverContentProps {
  className?: string
  children: React.ReactNode
  align?: Popover.Positioner.Props['align']
  side?: Popover.Positioner.Props['side']
  collisionBoundary?: Popover.Positioner.Props['collisionBoundary']
  collisionPadding?: Popover.Positioner.Props['collisionPadding']
  sideOffset?: number
  alignOffset?: number
}

function ActionPopoverContent({
  className,
  children,
  align = 'end',
  side = 'bottom',
  sideOffset = 0,
  alignOffset = 0,
  collisionPadding = 0,
  collisionBoundary = 'clipping-ancestors',
}: ActionPopoverContentProps) {
  return (
    <Popover.Portal>
      <Popover.Positioner
        side={side}
        sideOffset={sideOffset}
        align={align}
        alignOffset={alignOffset}
        collisionPadding={collisionPadding}
        collisionBoundary={collisionBoundary}
      >
        <Popover.Popup
          autoFocus={false}
          className={twMerge(
            'outline-none',
            'origin-[var(--transform-origin)]',
            'transition-opacity duration-150',
            'data-[starting-style]:opacity-0 data-[starting-style]:blur-sm',
            'data-[ending-style]:opacity-0 data-[ending-style]:blur-sm',
          )}
        >
          <ActionPopoverPopup className={twMerge('max-w-[calc(100vw-40px)] outline-none', className)}>
            <ResizableDiv className="outline-none">
              <Toolbar.Root className="outline-none">{children}</Toolbar.Root>
            </ResizableDiv>
          </ActionPopoverPopup>
        </Popover.Popup>
      </Popover.Positioner>
    </Popover.Portal>
  )
}

export { ActionPopoverContent }
